// extracted by mini-css-extract-plugin
export default {"image":"kY-z","loaded":"lY-z"};